import { Injectable } from '@angular/core';
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Router,
} from '@angular/router';
import { Observable } from 'rxjs';

const getTokenPermission = () => {
    const token = localStorage.getItem('token') || false;
    return token;
};

@Injectable({
    providedIn: 'root',
})
export class AuthGuard implements CanActivate {
    constructor(private router: Router) {
        if (!getTokenPermission()) {
            this.router.navigate(['signin']);
        }
    }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): Observable<boolean> | Promise<boolean> | boolean {
        if (!getTokenPermission()) {
            this.router.navigate(['signin']);
            return false;
        }
        return true;
    }

    canActivateChild(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): Observable<boolean> | Promise<boolean> | boolean {
        if (!getTokenPermission()) {
            this.router.navigate(['signin']);
            return false;
        }

        return true;
    }
}
